import moment from "moment/moment";
import { makeMultiSearch, makeSearch } from "../../UI/Search/Search";
import AcademicCalendarService from "../../../Services/AcademicCalendar.service";
import AcademicCalendarLookupModal from "./AcademicCalendarLookupModal";
const config = {
    loadOptions: (search, options) => {
        var _a, _b;
        const query = {
            names: [search],
        };
        if (options.futureTermsOnly) {
            query.startDateFrom = moment(Date.now());
        }
        if (options.currentTermsOnly) {
            query.endDateFrom = moment(Date.now());
            query.endDateTo = moment(Date.now()).add(3, "years");
        }
        if (options.futureTermsOnly || options.currentTermsOnly) {
            return AcademicCalendarService.lookupSearch(query, {
                max: (_a = options === null || options === void 0 ? void 0 : options.max) !== null && _a !== void 0 ? _a : 20,
            }).then((results) => results.data);
        }
        return AcademicCalendarService.search(search, (_b = options === null || options === void 0 ? void 0 : options.max) !== null && _b !== void 0 ? _b : 20);
    },
    value: "id",
    label: "name",
};
export const AcademicCalendarSearch = makeSearch(config);
export const AcademicCalendarMultiSearch = makeMultiSearch(Object.assign(Object.assign({}, config), { lookupModal: AcademicCalendarLookupModal }));
